import { useEffect, useState } from "react";

import { Destination } from "Constant/destination";

import { postSaveYandexMetrica } from "helpers/destinations/yandexMetrica";

import useHostFooterAction from "components/organisms/CreationModal/hooks/useHostFooterAction";
import SwalAlertComp from "components/SwalAlert";

/**
 * Yandex Metrica Web Conversions: OAuth plus an Active counter, then save.
 * There is no conversion-mapping step.
 */
const useYandexMetricaDestination = ({
    destinationCode,
    language,
    setSaveDisabled,
    setModalLoading,
    completeCreation,
    registerFooterAction,
}) => {
    const [data, setData] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const isActive = destinationCode === Destination.ymwc;
    const canCreate = Boolean(
        isActive &&
        isAuthenticated &&
        data?.selectedCounterId &&
        data?.partnerInstallID,
    );

    useEffect(() => {
        if (canCreate) setSaveDisabled(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canCreate]);

    const resetOnTypeChange = () => {
        setData(null);
        setIsAuthenticated(false);
    };

    const create = async () => {
        setModalLoading(true);
        try {
            if (!data?.selectedCounterId || !data?.partnerInstallID) return;

            const response = await postSaveYandexMetrica({
                partner_install_id: data.partnerInstallID,
                counter_id: data.selectedCounterId,
            });
            const createdId =
                response?.data?.id ?? response?.data?.destination_id;
            if (!response?.status || !createdId) return;

            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message || "Destination created successfully",
                icon: "success",
                timer: 3000,
            });
            resetOnTypeChange();
            await completeCreation(createdId);
        } finally {
            setModalLoading(false);
        }
    };

    useHostFooterAction(
        isActive ? registerFooterAction : undefined,
        `${Destination.ymwc}:form`,
        {
            label:
                language?.buttons?.create_destination ?? "Create destination",
            onSubmit: create,
            isDisabled: !canCreate,
        },
    );

    return {
        setData,
        setIsAuthenticated,
        resetOnTypeChange,
        create,
    };
};

export default useYandexMetricaDestination;
